class Placeholder {
    targetId = null;
    before = false;
    height = 100;
    setHeight = height => (this.height = height);
    move = (targetId, before) => {
        if (targetId !== this.targetId || before !== this.before) {
            this.targetId = targetId;
            this.before = before;
            return true;
        } else {
            return false;
        }
    };
} 

const placeholder = new Placeholder();

export default placeholder;